import { Injectable } from '@angular/core';
import { type IManagementResource } from './models/management-resource';
import {
  type IManagementTool,
  type IResourceContext,
} from './models/management-tool';

@Injectable({
  providedIn: 'root',
})
export class ManagementToolRegistryService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _resources = new Map<string, IManagementResource<any>>();
  private _tools = new Map<string, IManagementTool>();

  registerResource<T>(resource: IManagementResource<T>): void {
    this._resources.set(resource.name, resource);
  }

  registerTool(tool: IManagementTool): void {
    this._tools.set(tool.name, tool);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getResources(): IManagementResource<any>[] {
    return Array.from(this._resources.values());
  }

  getTools(): IManagementTool[] {
    return Array.from(this._tools.values());
  }

  getAvailableTools(contexts: IResourceContext[]): IManagementTool[] {
    const tools = this.getTools();
    const contextResources = new Set(
      contexts.map((context) => context.resource.resource)
    );

    return tools.filter((tool) => {
      if (!tool.resource) {
        return true;
      }
      return contextResources.has(tool.resource);
    });
  }
}
